import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export var pdokApi = createApi({
    reducerPath: 'pdokApi',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/' }),
    endpoints: function (builder) { return ({
        searchCityLocation: builder.query({
            query: function (query) { return "suggest?q=".concat(query, "&rows=100&fq=type:(woonplaats)&fl=id weergavenaam score"); },
            transformResponse: function (searchResponse) {
                return searchResponse.response.docs;
            }
        }),
        searchAddressLocation: builder.query({
            query: function (query) {
                return "suggest?q=".concat(query, "&rows=100&fq=type:(adres OR postcode)&fl=id weergavenaam score");
            },
            transformResponse: function (searchResponse) {
                return searchResponse.response.docs;
            }
        }),
        searchAllLocation: builder.query({
            query: function (query) { return "suggest?q=".concat(query, "&rows=100&&fl=id weergavenaam score"); },
            transformResponse: function (searchResponse) {
                return searchResponse.response.docs;
            }
        }),
        getLocation: builder.query({
            query: function (id) {
                return "lookup?id=".concat(id, "&fl=id woonplaatsnaam weergavenaam postcode centroide_ll huisnummer straatnaam");
            },
            transformResponse: function (searchResponse) {
                return searchResponse.response.docs[0];
            }
        })
    }); }
});
export var useLazySearchCityLocationQuery = pdokApi.useLazySearchCityLocationQuery, useLazySearchAddressLocationQuery = pdokApi.useLazySearchAddressLocationQuery, useLazyGetLocationQuery = pdokApi.useLazyGetLocationQuery, useLazySearchAllLocationQuery = pdokApi.useLazySearchAllLocationQuery;
